














































import { defineComponent, ref } from "@vue/composition-api";
import { useGetters } from "vuex-composition-helpers";
import useFetcher from "@use/useFetcher";
import EventCard from "@c/molecules/event/EventCard.vue";
import CreateButton from "@c/atoms/app/CreateButton.vue";
import SkeletonIndex from "@c/molecules/event/SkeletonIndex.vue";
import PlaceModel from "@/ts/models/placeClass";

export default defineComponent({
  name: "Events",

  components: {
    EventCard,
    CreateButton,
    SkeletonIndex
  },

  props: {
    place: Object as () => PlaceModel
  },

  setup(props, { root }) {

    var hash = ref(null);
    const place_id = parseInt(root.$route.params.id);

    var { entity: events, loading: loading_events } = useFetcher(
      "event/GET_EVENTS_BY_PLACE",
      {action_param:place_id}
    );

    return {
      events,
      loading_events
    };
  }
});
